package pl.decks.chartjs.radar.options

import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.style.FontStyle
import pl.decks.chartjs.style.FontWeightChart

data class FontOptions(
    val size: Int? = null,
    val family: String? = null,
    val weight: FontWeightChart? = null,
    val style: FontStyle? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        if (size != null) this.size = size.asDynamic()
        if (family != null) this.family = family.asDynamic()
        if (weight != null) this.weight = weight.toChartJs()
        if (style != null) this.style = style.toChartJs()
    }
}
